__turbopack_context__.v({
  "allRewards": "Rewards-module__92sZ5q__allRewards",
  "amount": "Rewards-module__92sZ5q__amount",
  "badge": "Rewards-module__92sZ5q__badge",
  "balance": "Rewards-module__92sZ5q__balance",
  "breadcrumb": "Rewards-module__92sZ5q__breadcrumb",
  "breakdown": "Rewards-module__92sZ5q__breakdown",
  "cardTop": "Rewards-module__92sZ5q__cardTop",
  "claimButton": "Rewards-module__92sZ5q__claimButton",
  "compact": "Rewards-module__92sZ5q__compact",
  "dailyCard": "Rewards-module__92sZ5q__dailyCard",
  "day": "Rewards-module__92sZ5q__day",
  "dayBonus": "Rewards-module__92sZ5q__dayBonus",
  "dayCurrent": "Rewards-module__92sZ5q__dayCurrent",
  "dayDone": "Rewards-module__92sZ5q__dayDone",
  "dayIcon": "Rewards-module__92sZ5q__dayIcon",
  "days": "Rewards-module__92sZ5q__days",
  "empty": "Rewards-module__92sZ5q__empty",
  "entry": "Rewards-module__92sZ5q__entry",
  "entryAmount": "Rewards-module__92sZ5q__entryAmount",
  "entryBalance": "Rewards-module__92sZ5q__entryBalance",
  "entryDate": "Rewards-module__92sZ5q__entryDate",
  "entryIcon": "Rewards-module__92sZ5q__entryIcon",
  "entryTitle": "Rewards-module__92sZ5q__entryTitle",
  "error": "Rewards-module__92sZ5q__error",
  "eyebrow": "Rewards-module__92sZ5q__eyebrow",
  "filters": "Rewards-module__92sZ5q__filters",
  "footer": "Rewards-module__92sZ5q__footer",
  "grid": "Rewards-module__92sZ5q__grid",
  "heroCoin": "Rewards-module__92sZ5q__heroCoin",
  "history": "Rewards-module__92sZ5q__history",
  "historyTools": "Rewards-module__92sZ5q__historyTools",
  "intro": "Rewards-module__92sZ5q__intro",
  "introTag": "Rewards-module__92sZ5q__introTag",
  "loading": "Rewards-module__92sZ5q__loading",
  "mobileBalance": "Rewards-module__92sZ5q__mobileBalance",
  "page": "Rewards-module__92sZ5q__page",
  "positive": "Rewards-module__92sZ5q__positive",
  "readyBadge": "Rewards-module__92sZ5q__readyBadge",
  "refresh": "Rewards-module__92sZ5q__refresh",
  "resetLine": "Rewards-module__92sZ5q__resetLine",
  "rewardHeadline": "Rewards-module__92sZ5q__rewardHeadline",
  "sectionHeader": "Rewards-module__92sZ5q__sectionHeader",
  "shell": "Rewards-module__92sZ5q__shell",
  "signIn": "Rewards-module__92sZ5q__signIn",
  "statusSpace": "Rewards-module__92sZ5q__statusSpace",
  "streakHeading": "Rewards-module__92sZ5q__streakHeading",
  "streakNote": "Rewards-module__92sZ5q__streakNote",
  "success": "Rewards-module__92sZ5q__success",
  "summary": "Rewards-module__92sZ5q__summary",
  "wallet": "Rewards-module__92sZ5q__wallet",
  "walletCoin": "Rewards-module__92sZ5q__walletCoin",
  "walletHint": "Rewards-module__92sZ5q__walletHint",
  "walletLabel": "Rewards-module__92sZ5q__walletLabel",
  "walletMeta": "Rewards-module__92sZ5q__walletMeta",
  "walletUnit": "Rewards-module__92sZ5q__walletUnit",
  "way": "Rewards-module__92sZ5q__way",
  "wayIcon": "Rewards-module__92sZ5q__wayIcon",
  "ways": "Rewards-module__92sZ5q__ways",
});
